// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const outViewportDropdownOffset = "1rem";
export const inlineDropdown = "InlineDropdownWrapper__inlineDropdown__NXA35";
export const expanded = "InlineDropdownWrapper__expanded__EiLlx";
export const arrow = "InlineDropdownWrapper__arrow__PRJto";
export const isMobile = "InlineDropdownWrapper__isMobile__mK8GN";
export const caption = "InlineDropdownWrapper__caption__P-H3I";
export const dropdownContainer = "InlineDropdownWrapper__dropdownContainer__n9kWV";
export const onRight = "InlineDropdownWrapper__onRight__qsK4G";
export const dropdownScrollable = "InlineDropdownWrapper__dropdownScrollable__+dWzV";
export const dropdownContent = "InlineDropdownWrapper__dropdownContent__tgsoZ";
export const selectedOption = "InlineDropdownWrapper__selectedOption__UU32F";
export const option = "InlineDropdownWrapper__option__rScRC font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const optionCaption = "InlineDropdownWrapper__optionCaption__TGdTE";
export const footerItem = "InlineDropdownWrapper__footerItem__naUiT";
export const note = "InlineDropdownWrapper__note__6jI8v";
export const group = "InlineDropdownWrapper__group__BeGYg";
export const groupName = "InlineDropdownWrapper__groupName__Wg3sW";
export const groupList = "InlineDropdownWrapper__groupList__jHg-J";
export const groupHint = "InlineDropdownWrapper__groupHint__ajciM font-faces__sansRegular__c8KXl font-faces__sans__uCf65";